import { useToast } from "@chakra-ui/react";
import { useQuery,useMutation,useQueryClient } from "@tanstack/react-query";
import createReview from "services/Admin/Reviews/createReview";
import updateReview from "services/Admin/Reviews/updateReview";
import deleteReview from "services/Admin/Reviews/deleteReview";
import getReviews from "services/Admin/Reviews/getReview";

const useGetReviews = (payload : { [key: string]: any })=>{
    return useQuery({queryKey:['getReviews', payload], queryFn: ()=>getReviews(payload)});
}
const useCreateReview = ()=>{
    const toast = useToast();
    const queryClient = useQueryClient();
    
    const onSuccess = ()=>{
        toast({ title: 'Review Created!!', status: 'success' });
        queryClient.invalidateQueries({queryKey: ['getReviews']})
    }
    const onError = () => {
        toast({ title: 'Error Creating Reviews!', status: 'error' });
    };
    return useMutation(createReview, {onSuccess, onError})
}
const useUpdateReview = ()=>{
    const toast = useToast();
    const queryClient = useQueryClient();
    
    const onSuccess = ()=>{
        toast({ title: 'Review Updated Successfuly!!', status: 'success' });
        queryClient.invalidateQueries({queryKey: ['getReviews']})
    }
    const onError = () => {
        toast({ title: 'Error Updating Reviews!', status: 'error' });
    };
    return useMutation(updateReview, {onSuccess, onError})
}

const useDeleteReview = ()=>{
    const toast = useToast();
    const queryClient = useQueryClient();
    
    const onSuccess = ()=>{
        toast({ title: 'Review Deleted Successfuly!!', status: 'success' });
        queryClient.invalidateQueries({queryKey: ['getReviews']})
    }
    const onError = () => {
        toast({ title: 'Error Deleting Reviews!', status: 'error' });
    };
    return useMutation(deleteReview, {onSuccess, onError})
}

export {useCreateReview, useGetReviews, useUpdateReview,useDeleteReview }